import type { CSSProperties } from "react"

export default function IconTextColor({
  className,
  style,
}: {
  className?: string
  style?: CSSProperties
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 30 29.9389"
      fill="none"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2751 0.11749C13.866 0.262159 13.5126 0.494461 13.2551 0.787643C13.145 0.913249 10.417 6.30614 6.58229 13.9798C1.20216 24.7457 0.0847741 27.0223 0.0303501 27.3281C-0.138149 28.2727 0.409165 29.3 1.31931 29.7477C1.6849 29.9275 1.74486 29.9388 2.32246 29.9372C2.85763 29.9357 2.97816 29.916 3.25812 29.7853C3.43477 29.7028 3.71827 29.5098 3.888 29.3564C4.18164 29.091 4.28757 28.8958 6.07879 25.3167L7.96103 21.5559L15.0008 21.5558L22.0406 21.5556L23.8999 25.2726C25.9582 29.3871 25.9672 29.4019 26.6798 29.7506C27.0393 29.9265 27.1055 29.9389 27.6791 29.9389C28.255 29.9389 28.3178 29.9269 28.6823 29.7477C29.6119 29.2903 30.1611 28.2163 29.9579 27.2523C29.849 26.7359 17.0423 1.13433 16.6976 0.744135C16.5362 0.561338 16.3056 0.394837 16.0158 0.251551C15.4486 -0.0287168 14.8241 -0.0768376 14.2751 0.11749ZM12.6492 12.179C11.3721 14.7336 10.3271 16.8367 10.3271 16.8527C10.3271 16.8687 12.4303 16.8818 15.0008 16.8818C17.5713 16.8818 19.6745 16.8687 19.6745 16.8527C19.6745 16.7951 15.0297 7.53437 15.0008 7.53437C14.9845 7.53437 13.9263 9.62447 12.6492 12.179Z"
        fill="currentColor"
      />
    </svg>
  )
}
